import React from 'react';

export default class DealerInfoBlock extends React.Component {
    constructor(props) {
        super(props);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.showPhoneNumber = this.showPhoneNumber.bind(this);
        this.renderStockStatus = this.renderStockStatus.bind(this);

        this.state = {
            showPhoneNumber: false,
            isChecked: props.data.selected === true
        }
    }

    toggleCheckbox() {
        this.setState({
            isChecked: !this.state.isChecked
        }, () => {
            this.props.onSelected(this.props.data, this.state.isChecked);
        });
    }

    showPhoneNumber() {
        this.setState({
            showPhoneNumber: true
        });
    }

    componentDidMount() {
        jQuery('[data-toggle="tooltip"]').tooltip();
    }

    componentDidUpdate() {
        jQuery('[data-toggle="tooltip"]').tooltip();
    }

    render() {
        let callConnectDisplay;
        if (this.props.data.hasCallConnect) {
            if (this.state.showPhoneNumber) {
                callConnectDisplay = <span><b>{this.props.data.callConnect}</b> - code {this.props.data.callConnectCode}</span>;
            }
            else {
                callConnectDisplay =
                    <a href="javascript:;"
                        onClick={this.showPhoneNumber}
                        data-callconnect={this.props.data.callConnect}
                        data-callconnect-code={this.props.data.callConnectCode}>Show phone number</a>;
            }
        }

        let distanceDisplay = this.props.data.name + " - " + (this.props.data.isLocal ? "Local" : this.props.data.distance + "km away");

        return (
            <div className="dealer-info-block clearfix">
                {this.props.placement === "Vertical" && this.renderStockStatus()}
                <div className="chk-toggle-label">
                    <label className="label-checkbox">
                        <input className="chk-toggle" type="checkbox" onChange={this.toggleCheckbox} checked={this.state.isChecked} />
                        <span></span>
                    </label>
                </div>
                <div className="distance-info">
                    <label onClick={this.toggleCheckbox}>{distanceDisplay}</label>
                    <div>{callConnectDisplay}</div>
                    {this.props.placement === "Gallery" && this.renderStockStatus()}
                </div>
            </div>
        );
    }

    renderStockStatus() {
        switch (this.props.data.stockStatus) {
            case "in-stock":
                return <div className="stock-status in-stock" data-toggle="tooltip" title="This dealer currently has the model listed in stock. The in-stock vehicle may have optional accessories installed. Please contact the dealer to confirm stock details.">Model in-stock</div>;
            case "similar-stock":
                return <div className="stock-status similar-stock" data-toggle="tooltip" title="The dealer may have matching demo stock and/or other colours of this vehicle available">Similar stock<i /></div>;
            case "to-order":
                return <div className="stock-status to-order" data-toggle="tooltip" title="Please enquire about availability with the dealer. To order stock may have delays in arriving.">To order<i /></div>;
        }
    }
}